import { AfterViewInit, Component, ElementRef, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatLabel } from '@angular/material/form-field';
import { ProductCardComponent } from '../product-card/product-card.component';
import { LoadingService } from '../../../core/services/shared-services/loading.service';
import { CountryVm } from '../../../core/models/country-vm';
import { ClientService } from '../../../core/services/client/client.service';
import { CatalogueService } from '../../../core/services/catalogue/catalogue.service';
import { Product } from '../../../core/models/product-models';
import { CartService } from '../../../core/services/cart/cart.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FilterComponent } from '../filter/filter.component';

@Component({
  selector: 'app-product-list',
  standalone: true,
  imports: [CommonModule, MatFormFieldModule, MatSelectModule, MatInputModule, MatIcon, ProductCardComponent, FilterComponent],
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent implements OnInit {
  iClientRepository = inject(ClientService);
  catalogueService = inject(CatalogueService);
  cartService = inject(CartService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  selectedCountry: string | null = null;
  protected countryList: CountryVm[] = [];
  displayedProducts: Product[] = [];
  countryIsoCode: string;
  isLoading = false;
  showScrollToTopButton = false;
  selectedCountryIsoCode: string;
  totalItem: number;

  @ViewChild('scrollAnchor', { static: false }) scrollAnchor: ElementRef;

  private loader = inject(LoadingService);
  loading$ = this.loader.loading$;

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    this.showScrollToTopButton = window.scrollY > 400;
  }
  private filterValues = {
    countryIsoCode: '',
  };
  ngOnInit(): void {
    this.loadCountryList();
    localStorage.removeItem("downloadOrderExcelReport");
    this.selectedCountry = localStorage.getItem('country');
    if (this.selectedCountry) {
      this.filterValues.countryIsoCode = this.selectedCountry;
      this.selectedCountryIsoCode = this.selectedCountry;
      this.loadProducts();
    }
    this.cartService.getProducts().subscribe(res => {
      this.totalItem = res.length;
    });
  }

  loadCountryList(): void {
    this.catalogueService.getCountryList(true).subscribe({
      next: data => {
        this.countryList = data;
      }
    });
  }

  onFiltersChanged(filters: { countryIsoCode: string }): void {
    this.filterValues = filters; // Store the filter values
    this.displayedProducts = [];
    this.isLoading = false;
    this.loadProducts();
    this.cartService.removeAllCart();
  }
  onCartClick() {
    this.router.navigateByUrl('cart')
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  refresh(): void {
    this.displayedProducts = [];
    this.loadProducts();
  }

  loadProducts(): void {
    this.isLoading = true;
    (this.catalogueService.loadProductList(this.filterValues.countryIsoCode)).subscribe({
      next: (response: any) => {
        if (response && response.catalogue && response.catalogue.item) {
          this.displayedProducts = this.displayedProducts.concat(response.catalogue.item);
        } else {
          console.error('Invalid response structure', response);
        }
        this.isLoading = false;
      },
      error: (err: any) => {
        console.error('Error loading products', err);
        this.isLoading = false;
      }
    });
  }

}
